import Button from '@mui/joy/Button'
import { styled } from '@mui/joy/styles'
import Typography from '@mui/joy/Typography'
import { type FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const ErrorFallbackContainer = styled('div')`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`

export const ErrorFallback: FC<{ error?: Error }> = ({ error }) => {
  const { t } = useTranslation()

  useEffect(() => {
    console.error(error)
  }, [])

  const handleRefreshPage = (): void => {
    location.assign('/')
  }
  return (
    <ErrorFallbackContainer>
      <Typography level={'h1'}>{t('common.error')}</Typography>
      <Typography level={'body-lg'}>{t('common.try-refresh')}</Typography>
      <Button onClick={handleRefreshPage}>{t('common.go-to-homepage')}</Button>
    </ErrorFallbackContainer>
  )
}
